import { X } from 'lucide-react'
import { useEffect, useState } from 'react'

import { KeyboardPress } from '@/components/ui/KeyboardPress'
import { cn } from '../../lib/utils'
import { InsuranceIndication } from '../../models/insuranceIndication'
import { InsuranceQuote } from '../../models/insuranceQuote'
import { ChatIndicationDetailsContent } from './ChatIndicationDetailsContent'

export const SIDEBAR_WIDTH = 500

export function ChatIndicationDetails({
  isVisible,
  handleClose,
  indication,
  actions,
}: {
  isVisible: boolean
  handleClose: (indication: InsuranceIndication | InsuranceQuote | null) => void
  indication: InsuranceIndication | InsuranceQuote | null
  /** Links and CTAs for this indication — see IndicationDetailActions. */
  actions?: React.ReactNode
}) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    const id = requestAnimationFrame(() => setIsMounted(true))
    return () => cancelAnimationFrame(id)
  }, [])
  if (!indication) return null

  return (
    <div
      className={cn(
        `fixed top-0 right-0 bottom-0 w-[99%] pl-5 transition-all duration-300 md:w-[500px]`,
        isMounted && isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      )}
    >
      <KeyboardPress callback={() => handleClose(indication)} />
      <div
        style={{ boxShadow: '-4px 0 6px 0 rgba(0, 0, 0, 0.05)' }}
        className="bg-background flex h-full overflow-y-auto px-4 py-6 md:px-8 md:py-10"
      >
        <div
          className="bg-background absolute top-5 -left-1 flex h-9 w-9 cursor-pointer items-center justify-center rounded-full"
          onClick={() => handleClose(indication)}
          style={{ boxShadow: '-4px 0 6px 0 rgba(0, 0, 0, 0.05)' }}
        >
          <X className="text-neutral-400" />
        </div>

        <ChatIndicationDetailsContent indication={indication} actions={actions} />
      </div>
    </div>
  )
}
